export default {
      id: "i-mailru-usage",
      viewBox: "0 0 378.632 378.632",
      url: __webpack_public_path__ + "img/sprite.svg#i-mailru",
      toString: function () {
        return this.url;
      }
    }